import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { debounceTime } from 'rxjs';
import { InternalTemplateController } from 'src/app/domain/controllers/internal-template.controller';
import { InternalTemplateEntity } from 'src/app/domain/entities/internal-template.entity';
import { RaEmptyComponent } from '../ra-empty/ra-empty.component';
import { RaFilletComponent } from '../ra-fillet/ra-fillet.component';
import { RaInputComponent } from '../ra-input/ra-input.component';
import { RaLoadingComponent } from '../ra-loading/ra-loading.component';
import { RaModalComponent } from '../ra-modal/ra-modal.component';

@Component({
    selector: 'ra-modal-list-internal-templates',
    templateUrl: 'ra-modal-list-internal-templates.component.html',
    styleUrl: 'ra-modal-list-internal-templates.component.scss',
    imports: [
        ReactiveFormsModule,
        RaModalComponent,
        RaLoadingComponent,
        RaEmptyComponent,
        RaInputComponent,
        RaFilletComponent,
        TranslatePipe,
    ],
})
export class RaModalListInternalTemplatesComponent implements OnInit {
    public message = input<string>();
    public category = input<string>();
    public close = output();
    public selectInternalTemplate = output<InternalTemplateEntity>();
    public loading = signal(true);
    public internalTemplates = signal<InternalTemplateEntity[]>([]);
    public internalTemplatesFiltered = signal<InternalTemplateEntity[]>([]);
    public searchControl = new FormControl('');

    // * [Injects]
    private _internalTemplateController = inject(InternalTemplateController);

    ngOnInit(): void {
        this._getInternalTemplates();
        this._listenSearchControl();
    }

    private _getInternalTemplates(): void {
        this.loading.set(true);
        this._internalTemplateController.getAll(this.category()).subscribe({
            next: templates => {
                this.internalTemplates.set(templates);
                this.internalTemplatesFiltered.set(templates);
                this.loading.set(false);
            },
            error: () => this.loading.set(false),
        });
    }

    private _filterInternalTemplates(): void {
        const searchValue = this.searchControl.value?.toLowerCase().trim() || '';

        if (!searchValue) {
            this.internalTemplatesFiltered.set(this.internalTemplates());
            return;
        }

        this.internalTemplatesFiltered.set(
            this.internalTemplates().filter(
                template =>
                    template.title?.toLowerCase().includes(searchValue) ||
                    template.categoryDescription?.toLowerCase().includes(searchValue)
            )
        );
    }

    private _listenSearchControl(): void {
        this.searchControl.valueChanges
            .pipe(debounceTime(600))
            .subscribe(() => this._filterInternalTemplates());
    }
}
